/**
 * Created by john on 7/17/15.
 */

'use strict';

const NavBarItemStore           = require('../stores/NavBarItemStore.es');
const NavBarUIStateStore        = require('../stores/NavBarUIStateStore.es');
const SearchStore               = require('../stores/SearchStore.es');
const NavBarHamburgerStateStore = require('../stores/NavBarHamburgerStateStore.es');
const CartStore                 = require('../../../stores/CartStore.es');
const CartCopyStore             = require('../../../stores/CartCopyStore.es');

/**
 * Registers the nav bar stores with the specified component.
 * @param App {Fluxible} A top level component that will be connected to the stores.
 */
module.exports = (App) => {
    App.registerStore(NavBarItemStore);
    App.registerStore(NavBarUIStateStore);
    App.registerStore(SearchStore);
    App.registerStore(NavBarHamburgerStateStore);
    App.registerStore(CartStore);
    App.registerStore(CartCopyStore);

    return App;
};



// WEBPACK FOOTER //
// ./assets/js/global/core/nav/helpers/connectToNavBar.es.js